module.exports = require("./dist/vue.js");


/*****************
 ** WEBPACK FOOTER
 ** vue (bower component)
 ** module id = 1
 ** module chunks = 0
 **/